// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__28YpP","inner":"Form_inner__3pOb9","range":"Form_range__3AI50","name":"Form_name__6e4ef","actions":"Form_actions__1o21s"};